import PropTypes from 'prop-types';
import {CookiesProvider} from 'react-cookie';
import {Provider} from 'react-redux';

import {ConnectedRouter as Router} from 'connected-react-router';

import LocalizationProvider from '../../../containers/Localization/LocalizationProvider';
import createStore from '../../../redux/store';
import history from '../../../services/history';

const store = createStore();

function ContextProvider({children}) {
  return (
    <CookiesProvider>
      <Provider store={store}>
        <LocalizationProvider>
          <Router history={history}>{children}</Router>
        </LocalizationProvider>
      </Provider>
    </CookiesProvider>
  );
}

ContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ContextProvider;
